<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2020-04-10 11:01:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div class="apply"  :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
   <img class="sub-logo2" src="../assets/logo5.png">
  <div class="content">
    <div class="body">
     <div class="registered">
          <div class="title">填写个人信息</div>
                <van-field
                  v-model="name"
                  required
                  label="真实姓名"
                  :left-icon="require('../assets/user.png')"
                  placeholder="请输入您的姓名"
              />
              <van-field
                  required
                  label="性别"
                  :left-icon="require('../assets/sex.png')">
                  <template #input>
                    <van-radio-group v-model="sex" direction="horizontal">
                      <van-radio name="1">男</van-radio>
                      <van-radio name="2">女</van-radio>
                    </van-radio-group>
                  </template>
              </van-field>
                <van-field
                  v-model="tel"
                  required
                  label="电话"
                  :left-icon="require('../assets/tel.png')"
                  placeholder="请输入您的电话"
              />
              
              <van-row class="bottom" type="flex" justify="center">
                <van-col ><van-button type="info" class="confirm" @click="editUser()">提交</van-button></van-col>
              </van-row>
            <div class="shuming">
                <p>对您填写的信息，</p>
                <p>我们将严格遵守《统计法》予以保密，</p>
                <p>所得调查数据仅用于科学研究需要。</p>
                <p>请根据您的实际情况放心填写</p>
            </div>
     </div>
    </div>
  </div>
  <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
import Cookies from 'js-cookie'
import axios from 'axios'


export default {
  name: 'Apply',
  data() {
    return {
      isSubmit: false,
      name: '',
      sex: '',
      tel: '',
      uid: '', //用户ID
      openid: '' 
    };
  },

  methods: {
        // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
      // 修改用户信息
      editUser(){
        this.name = this.name.trim();
        this.tel = this.tel.trim();
        if(!this.name || !this.tel || !this.sex){
            this.customAlert("个人信息请填写完整")
            return false
        }
        // 判断手机号格式
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(this.tel)) {
            this.customAlert("请输入准确的手机号")
            return false
        }
        if(this.isSubmit){
            this.customAlert('正在提交')
            return false
        }
        this.isSubmit = true
        let data = {}
        data.openid = this.openid
        data.tel = this.tel
        data.name = this.name
        data.sex = this.sex
        Http.post(api.editUserInfo, data).then((response) => {
            this.isSubmit = false
            if(response.code == 1){
                // 提交成功
                this.customAlert('提交成功')
                this.$router.push({ name: "Hospital"})
                return false
            }else{
                // 发送失败
                this.customAlert('修改失败')
                return false
            }
          })

        return false;

      },
      // 获取用户信息
      getUserInfo(){
        // 视频数据
        let data = {}
        data.openid = this.openid
        Http.post(api.getUserInfo, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                const data = response.data
                this.name = data.name
                this.tel = data.tel
                this.sex = data.sex
            } 
            return 
        })
      }
  },
  mounted: function() {
    this.uid = Cookies.get('uid')
    this.openid = Cookies.get('openid')
    // 跳转到首页
    if(!this.uid){
        this.$router.push({ name: "Index"})
    }
    // 获取用户信息
    this.getUserInfo()
  }

};
</script>

<style lang="less">
.apply {
  font-size: 16px;
    display: flex;
    height: 100vh;
    flex-direction: column;

     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
  .content {
    position: relative;
    overflow: hidden;
    height: 90%;
    background-color: #fff;
    margin: 60px 20px;
    .registered {
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 20px;
        .title{
          margin-top: 20px;
          margin-bottom: 28px;
          font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
        .van-cell {
          align-items: center;
          border-bottom: 1px solid #dcdcdc;
          font-size: 14px;
          margin-top: 10px;
        }
        .bottom {
            margin-top: 30px;
            margin-bottom: 30px;
            .confirm {
              width: 100px;
              height: 40px;
              border-radius: 4px;
              font-size: 18px;
            }
        }
        .shuming {
            position: absolute;
            bottom: 12px;
            font-size: 12px;
            color: #969799;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Apply.vue